import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { EventStreamDataset } from 'shell-models-lib';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EventStreamDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                table: '*'
            }
        }
    }
})
export class EventStreamDatasetAdapter extends TabularTypeDatasetAdapter<EventStreamDataset, Model.DatasetResource> {
    protected override async _toResource(dataset: EventStreamDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(EventStreamDataset).name);
    }

    protected override async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: EventStreamDataset
    ): Promise<EventStreamDataset> {
        const res = await this._toModelInternal(modelDatasetResource, dataset, EventStreamDataset.MODEL);
        res.isV2 = true;
        return res;
    }
}
